import { emptyA4Canvas, rectColored, fillWhiteBackground } from '../canvasDraw';
import { drawMainFrame, mainFrameRect } from './rects';
import { drawZOnOther } from './drawLines';
import { canvasFillStyled, canvasFonted, canvasTextFonted, canvasTextWidthFonted } from '../../fun-js-lib/canvas';
import Rect from '../../fun-js-lib/geometry/Rect';
import { maxNLinesOnMainPageWorkDescription, normalWorkDescriptionFont } from './lower/workDescription';
import Dot from '../../fun-js-lib/geometry/Dot';
import { workDescriptionLinesWidths } from './texts';
import { drawTextLines } from './draw-styled-text/draw-text-lines';
import { getLinesFonted } from './draw-styled-text/line';

/**
 * @param {import('../constructionLog').LogPage} page 
 * @param {string} linesColor 
 */
export const otherPageImg = (page, linesColor) => {
  let canvas = emptyA4Canvas()
  let context = canvas.getContext('2d')
  fillWhiteBackground(canvas)

  drawMainFrame(context, linesColor)
  drawLabel(context, linesColor)
  drawContent(page, context)
  drawZOnOther(context, page)
  
  return canvas.toDataURL('image/jpeg', 1)
}

/**
 * @param {import('../constructionLog').LogPage} page 
 * @param {CanvasRenderingContext2D} context 
 */
function drawContent (page, context) {
  const rect = otherPageContentRect()
  const font = normalWorkDescriptionFont
  const lines = getLines(context, page)
  const lineInterval = baseLineInterval()
  canvasFonted(context, font, () => {
    drawTextLines(context, lines, linesRange(), rect, lineInterval)
  })
}

const linesRange = () => ({
  start: maxNLinesOnMainPageWorkDescription,
  end: maxNLinesOnMainPageWorkDescription + maxNLinesOnOtherPage
})

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {import('../constructionLog').LogPage} page 
 * @returns 
 */
function getLines (context, page) {
  const json = page.work_description
  const linesWidths = workDescriptionLinesWidths()
  const font = normalWorkDescriptionFont
  const lines = getLinesFonted(context, json, linesWidths, font)
  return lines
}

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {string} linesColor 
 */
function drawLabel (context, linesColor) {
  const frame = mainFrameRect()
  const label = 'ОПИС РАДА'
  const font = '30px Arial'
  let position = new Dot({
    x: frame.x + 70,
    y: frame.y + 20
  })
  const backgroundRectWidth = canvasTextWidthFonted(context, label, font)
  rectColored(context, position.x - 20, frame.y - 2, backgroundRectWidth + 40, 10, 'white')
  canvasFillStyled(context, linesColor, () => {
    canvasTextFonted(context, label, position, font)
  })
}

export function otherPageContentRect () {
  const frame = mainFrameRect()
  return Rect.plain({
    x: frame.x + 20,
    y: frame.y,
    w: frame.w - 40,
    h: baseLineInterval() * maxNLinesOnOtherPage
  })
}

export const maxNLinesOnOtherPage = 31

export let emptyCanvas = emptyA4Canvas()

export function baseLineInterval () {
  return 55.555
}